module.exports = __webpack_public_path__ + "media/earth.2242122d.webm";